module.exports = __webpack_public_path__ + "media/images/players/TRINGALE_CAMERON-13bf31bd05cf10aa1b0f2a7a36ed4a82.png";